import { API_URL } from '@/consts/urls';
import { getContext } from '@/context';

export const DEFAULT_AVATAR =
  'https://cdn190.picsart.com/232804661007900.png?to=fixed&r=100x100';

export const fetchUserAvatar = async (userId: number): Promise<string> => {
  try {
    const response = await getContext().utils.api.fetch(
      `${API_URL}/users/${userId}/profile`
    );
    if (!response.ok) return DEFAULT_AVATAR;
    const json = await response.json();
    const photo = json?.response
      ?.flatMap(
        (card: { data?: { user?: { photo?: string } }[] }) => card.data ?? []
      )
      .find((item: { user?: { photo?: string } }) => item?.user?.photo)
      ?.user?.photo;
    return photo || DEFAULT_AVATAR;
  } catch {
    return DEFAULT_AVATAR;
  }
};
